<script setup lang="ts">
import { computed, onMounted } from 'vue';
import {
  EntityListPage,
  getAggregatorsLookup,
  getDomainsLookup,
  type DomainLite,
  type EntityConfig,
} from '@botto/core';
import { domainsStore } from '../../api';
import type { Domain } from '../../api';

const aggregatorsLookup = getAggregatorsLookup();
const trackerDomainsLookup = getDomainsLookup();

onMounted(async () => {
  await Promise.all([aggregatorsLookup.ensureLoaded(), trackerDomainsLookup.ensureLoaded()]);
  // If first paint raced init / got an empty parse, force one retry.
  if (!trackerDomainsLookup.items.value.length && !trackerDomainsLookup.error.value) {
    await trackerDomainsLookup.reload();
  }
});

const config = computed<EntityConfig<Domain>>(() => ({
  title: 'Домен',
  titlePlural: 'Домены',
  popupWidth: 560,
  formColCount: 1,
  columns: [
    { dataField: 'id', caption: 'ID', dataType: 'number', width: 80 },
    { dataField: 'domain', caption: 'Домен' },
    {
      dataField: 'tracker_domain_id',
      caption: 'Tracker domain',
      dataType: 'number',
      calculateDisplayValue: (row) =>
        row.tracker_domain_id != null
          ? trackerDomainsLookup.labelOf(row.tracker_domain_id)
          : '',
    },
    {
      dataField: 'aggregator_id',
      caption: 'Агрегатор',
      dataType: 'number',
      calculateDisplayValue: (row) => aggregatorsLookup.labelOf(row.aggregator_id),
    },
  ],
  fields: [
    { dataField: 'id', label: 'ID', editOnly: true, editorOptions: { readOnly: true } },
    {
      dataField: 'tracker_domain_id',
      label: 'Домен (трекер)',
      required: true,
      lookup: trackerDomainsLookup,
      mapLookupItem: (item: DomainLite | null) => ({
        domain: item?.name || item?.hostname || '',
      }),
    },
    {
      dataField: 'domain',
      label: 'Название',
      required: true,
      editorOptions: { readOnly: true },
      helpText: 'Подставляется из выбранного домена трекера',
    },
    { dataField: 'aggregator_id', label: 'Агрегатор', lookup: aggregatorsLookup },
  ],
}));
</script>

<template>
  <EntityListPage :config="config" :store="domainsStore" />
</template>
